// extracted by mini-css-extract-plugin
module.exports = {"shimmerBanner":"_3yjvy","shimmerHeading":"_3Omtg","outer":"_1BOC5","seoNav":"_3lbLk"};